export default {"src":"/_next/static/media/comce.22f2b0f5.svg","height":179,"width":178};